<template>
  <div :style="'padding 10px; position: relative; width: 100%; height: 100%; overflow: hidden;'">
    <ui-loading v-if="ui.loading.is_open === 1" :loading="ui.loading" :images="images"></ui-loading>
    <div v-if="!loadding" style="width: 100%;height: 100%;">
      <map-line ref="map" :project-id="projectId" :project-uid="projectUid" :member="member" :map="map" :ui="ui" :apiroot="apiroot"></map-line>
      <ui-element :project-id="projectId" :member="member" :apiroot="apiroot" :ui="ui"></ui-element>
      <ui-music ref="music" v-if="ui.music.is_open === 1" :music="ui.music"></ui-music>
    </div>
  </div>
</template>
<script>
import { getSimulatorBodyStyle, getSimulatorBodyItem } from '@/libs/tool'
import { MapLine } from './components/map'
import { UiLoading, UiElement, UiMusic } from './components/ui'

var rootUrl = process.env.NODE_ENV === 'development' ? 'http://local.share.com' : ''
export default {
  name: 'app',
  components: {
    MapLine,
    UiLoading,
    UiElement,
    UiMusic
  },
  data () {
    return {
      apiroot: rootUrl,
      loadding: true,
      projectId: null,
      projectUid: null,
      images: [],
      project: {},
      authorize: {},
      formwork: '',
      formwork_attr: '',
      member: {},
      ui: {
        loading: {},
        background: {}
      },
      map: {}
    }
  },
  watch: {
  },
  methods: {
    inArray (search, array) {
      for (var i in array) {
        if (array[i] === search) {
          return true
        }
      }
      return false
    },
    getSimulatorBodyStyle (background) {
      return getSimulatorBodyStyle(background)
    },
    getSimulatorBodyItem (obj) {
      return getSimulatorBodyItem(obj)
    },
    getProject () {
      var timestamp = Date.parse(new Date())
      this.$http.get(this.apiroot + '/open/project?id=' + this.projectId + '&puid=' + this.projectUid + '&' + timestamp).then((response) => {
        this.loadding = false
        this.$set(this, 'images', response.data.data.images)
        this.$set(this, 'project', response.data.data.project)
        this.$set(this, 'authorize', response.data.data.authorize)
        this.$set(this, 'formwork', response.data.data.formwork)
        this.$set(this, 'formwork_attr', response.data.data.formwork_attr)
        this.$set(this, 'member', response.data.data.member)
        this.$set(this, 'ui', response.data.data.ui)
        this.$set(this, 'map', response.data.data.map)
        if (this.authorize) {
          this.init(this.authorize.id)
        }
        this.$Spin.hide()
      })
    },
    init (authorizeId) {
      if (window.kkWeChat) {
        var project = this.project
        var url = this.project.url + '?shareId=' + (this.member.id ? this.member.id : 'none')
        var me = this
        window.kkWeChat.readyFn = function () {
          me.$refs.map.refBgScale()
          me.$refs.music.initMusic()
        }
        window.kkWeChat.init(authorizeId, function () {
          window.kkWeChat.setShare(url, project, function (doing, status, res) {
            me.triggerShare(doing, status, res)
          })
        })
      }
    },
    triggerShare (doing, status, res) {
      var postData = {}
      postData['UID'] = this.member['UID'] ? this.member['UID'] : '_NONO_'
      postData['id'] = this.projectId
      postData['pu_id'] = this.projectUid
      postData['status'] = status === 1 ? 200 : 209
      this.$http.post(this.apiroot + '/open/share', postData).then((response) => {
        if (response.data.code) {
          if (status === 1) {
            this.$Message.success('分享成功')
          } else {
            this.$Message.info('取消分享')
          }
        }
      })
    }
  },
  mounted () {
    this.projectId = window.pid
    if (this.projectId === '{{ $projectId }}') {
      this.projectId = '51'
    }
    this.projectUid = window.puid
    if (this.projectUid === '{{ $projectUid }}') {
      this.projectUid = '75'
    }
    this.$Spin.show()
    this.getProject()
  }
}
</script>
<style>
.w-100 { width: 100px; }
</style>



// WEBPACK FOOTER //
// src/App.vue